<template>
  <section>
    <editar-usuario />
    <h3 class="primary--text"><v-icon info>group</v-icon>Usuarios</h3>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-tooltip bottom>
            <v-btn
              v-if="!filterShow"
              class="btn-refresh"
              icon
              slot="activator"
              @click="
                v => {
                  filterShow = true;
                }
              "
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              v-if="filterShow"
              class="btn-refresh"
              icon
              slot="activator"
              @click="
                v => {
                  filterShow = false;
                }
              "
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Ocultar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              @click.native="listarUsuarios()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <v-layout row wrap v-if="filterShow">
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Usuario"
              single-line
              hide-details
              @input="filterUsuario"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Nombre completo"
              single-line
              hide-details
              @input="filterNombreCompleto"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Correo"
              single-line
              hide-details
              @input="filterCorreo"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="lista_usuarios"
          class="elevation-1"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-data-text="Sin datos"
        >
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.nombre_usuario }}</td>
            <td class="text-xs-center">
              {{ items.item.nombre_completo }}
            </td>
            <td class="text-xs-center">{{ items.item.correo }}</td>
            <td>
              <ul>
                <li v-for="rol in items.item.roles" :key="rol.id">
                  {{ rol.descripcion }}
                </li>
              </ul>
            </td>
            <td title="Activar/Desactivar usuario">
              <v-switch
                value
                :input-value="items.item.id_estado === '1' ? true : false"
                @change="cambiarEstado(items.item)"
              ></v-switch>
            </td>
            <td>
              <v-chip
                label
                color="success"
                text-color="white"
                v-if="items.item.id_estado === '1'"
              >
                {{ items.item.estado.descripcion }}
              </v-chip>
              <v-chip
                label
                color="error"
                text-color="white"
                v-if="items.item.id_estado === '2'"
              >
                {{ items.item.estado.descripcion }}
              </v-chip>
            </td>
            <td class="nowrap">
              <v-tooltip bottom>
                <v-btn icon slot="activator" @click="editarUsuario(items.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import EditarUsuario from "./dialogs/EditarUsuario.vue";

export default {
  mixins: [crud],
  async mounted() {
    this.cargarSistemas();
    await this.listarUsuarios();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
  },
  data() {
    return {
      //Filtros
      // -------------------------
      filterShow: false,
      filters: {
        nombre_usuario: "",
        nombre_completo: "",
        correo: ""
      },
      //--------------------------
      graphql: true, // Definiendo el CRUD con Graphql
      url: "usuarios",
      lista_usuarios: [],
      user: this.$storage.getUser(),
      ids_sistemas: [],
      headers: [
        {
          text: this.$t("user.crud.user"),
          value: "nombre_usuario",
          align: "center"
        },
        {
          text: this.$t("user.crud.fullname"),
          value: "nombre_completo",
          align: "center",
          sortable: false
        },
        { text: this.$t("user.crud.email"), value: "correo", align: "center" },
        { text: "Roles", value: "roles", sortable: false },
        { text: this.$t("common.active"), sortable: false, align: "center" },
        {
          text: this.$t("user.crud.status"),
          value: "id_estado",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      dataGraphql: `
        id
        ci
        nombre_usuario
        correo
        id_estado
        ultimo_login
        personas {
          ap_paterno
          ap_materno
          ap_casada
          nombres
        }
        estado {
          descripcion
        }
        roles {
          id
          descripcion
          id_estado
        }
      `,
      form: {
        usuario: "",
        contrasena: "",
        email: "",
        id_entidad: null,
        id_rol: null
      },
      // filters: [
      //   {
      //     field: "nombre_usuario",
      //     typeG: "String",
      //     type: "text",
      //     label: "Nombre de usuario"
      //   },
      //   {
      //     field: "correo",
      //     typeG: "String",
      //     type: "text",
      //     label: "Correo electrónico"
      //   }
      // ],
      valid: true,
      active: []
    };
  },
  methods: {
    cargarSistemas() {
      let roles = this.user.roles;
      roles.forEach(element => {
        if (parseInt(element.id) == 86) {
          this.ids_sistemas.push(1);
        }
        if (parseInt(element.id) == 43) {
          this.ids_sistemas.push(2);
        }
      });
    },
    async listarUsuarios() {
      this.lista_usuarios= []
      try {
        let res = await this.$service.graphql({
          query: `
          query{
            usuarios{
              rows{
                id
                ci
                nombre_usuario
                correo
                id_estado
                ultimo_login
                personas {
                  ap_paterno
                  ap_materno
                  ap_casada
                  nombres
                }
                estado {
                  descripcion
                }
                roles {
                  id
                  descripcion
                  id_estado
                  id_sistema
                }
              }
            }
          }
        `
        });
        this.lista_usuarios = res.usuarios.rows;
        this.lista_usuarios.forEach(element => {
          if (element.personas.length > 0) {
            element.nombre_completo = `${element.personas[0].nombres} ${element.personas[0].ap_paterno} ${element.personas[0].ap_materno}`;
          } else {
            element.nombre_completo = "Sin datos personales";
          }
          let roles_sistema = [];
          element.roles.forEach(rol => {
            if (this.ids_sistemas.includes(parseInt(rol.id_sistema))) {
              roles_sistema.push(rol);
            }
          });
          element.roles = [...roles_sistema];
        });
      } catch (error) {
        console.log(error);
      }
    },
    editarUsuario(item) {
      let obj = item;
      this.$bus.$emit("openDialogEditarUsuario", obj);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "2" ? 1 : 2;
      let data = {
        id_estado: value
      };
      let mensaje =
        item.id_estado == "2"
          ? "¿Esta seguro de habilitar el usuario?"
          : "¿Esta seguro de deshabilitar el usuario?";
      this.$confirm(
        mensaje,
        async () => {
          try {
            await this.$service.graphql({
              query: `
            mutation edit($id: ID!, $usuario: EditUsuario!) {
              usuarioEdit(id: $id, usuario: $usuario) {
                id
              }
            }
          `,
              variables: {
                id: item.id,
                usuario: data
              }
            });
            if (value === 1) {
              this.$message.success("Usuario habilitado");
            } else {
              this.$message.warning("Usuario deshabilitado");
            }
            await this.listarUsuarios();
          } catch (error) {
            console.log(error);
          }
        },
        async () => {
          await this.listarUsuarios();
        }
      );
    },
    // ----------------------------------------------------
    // Filtros
    // -----------------------------------------------------
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter("nombre_usuario", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.nombre_usuario != null) {
            return item.nombre_usuario
              .toLowerCase()
              .includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      cf.registerFilter("nombre_completo", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.nombre_completo != null) {
            return item.nombre_completo
              .toLowerCase()
              .includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      cf.registerFilter("correo", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.correo != null) {
            return item.correo.toLowerCase().includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterUsuario(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nombre_usuario: val
      });
    },
    filterNombreCompleto(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nombre_completo: val
      });
    },
    filterCorreo(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        correo: val
      });
    }

    // -----------------------------------------------------
  },
  components: {
    CrudTable,
    EditarUsuario
  }
};
</script>

<style lang="scss">
.btn-refresh {
  min-width: 52px;

  .v-btn__content {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/usuario_sistema/Usuario.vue